module.exports = __webpack_public_path__ + "static/media/a4c-in-store-blue.33a03c4f.jpg";